/**
 * contractUtils — costanti condivise sezione Contratti (★ Fase 8).
 * ★ Fase 32 — etichette localizzate a runtime (getter → lingua attiva).
 */
import i18n from '../../i18n';

const ct = (k, fb) => i18n.t(`contractsPage.${k}`, fb);

export const STATUS_META = {
  get sent() { return { label: ct('stSent', 'Inviato'), cls: 'bg-amber-100 text-amber-800 border-amber-200' }; },
  get viewed() { return { label: ct('stViewed', 'Visualizzato'), cls: 'bg-sky-100 text-sky-800 border-sky-200' }; },
  get otp_verified() { return { label: ct('stOtpVerified', 'Email verificata'), cls: 'bg-cyan-100 text-cyan-800 border-cyan-200' }; },
  get identity_submitted() { return { label: ct('stIdentity', 'Documenti caricati'), cls: 'bg-violet-100 text-violet-800 border-violet-200' }; },
  get signed() { return { label: ct('stSigned', 'Firmato — da verificare'), cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' }; },
  get approved() { return { label: ct('stApproved', 'Approvato ✓'), cls: 'bg-emerald-600 text-white border-emerald-700' }; },
  get rejected() { return { label: ct('stRejected', 'Rifiutato'), cls: 'bg-red-100 text-red-800 border-red-200' }; },
  get voided() { return { label: ct('stVoided', 'Annullato'), cls: 'bg-slate-100 text-slate-600 border-slate-200' }; },
  get expired() { return { label: ct('stExpired', 'Scaduto'), cls: 'bg-orange-100 text-orange-800 border-orange-200' }; },
};

export const AI_VERDICT_META = {
  get alta() { return { label: ct('aiHigh', 'ALTA compatibilità'), cls: 'text-emerald-700' }; },
  get media() { return { label: ct('aiMedium', 'MEDIA compatibilità'), cls: 'text-amber-700' }; },
  get bassa() { return { label: ct('aiLow', 'BASSA compatibilità'), cls: 'text-red-700' }; },
  get non_valutabile() { return { label: ct('aiManual', 'Da verificare a mano'), cls: 'text-slate-500' }; },
};

export const FIELD_RE = /\{\{\s*([a-zA-Z0-9_]{1,40})\s*\}\}/g;

export function extractFieldKeys(html) {
  const seen = new Set();
  const out = [];
  for (const m of (html || '').matchAll(FIELD_RE)) {
    if (!seen.has(m[1])) { seen.add(m[1]); out.push(m[1]); }
  }
  return out;
}

export function renderWithValues(html, values) {
  return (html || '').replace(FIELD_RE, (_, key) => {
    const v = (values?.[key] || '').trim();
    if (!v) return '<span style="background:#FBF3DF;padding:0 4px;border-radius:3px">________</span>';
    const esc = v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return `<strong>${esc}</strong>`;
  });
}

export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '—');
